// POST /api/Admin/stripe/customer-addresses/backfill
export interface StripeCustomerAddressBackfillResult {
  updated: number;
  skipped: number;
  failed: number;
  skippedFacilityIds: string[];
  skippedCorporationIds: string[];
  automaticTaxStatusCounts: Record<string, number>;
  resolvedJurisdictionCounts: Record<string, number>;
  unresolvableFacilityIds: string[];
  unresolvableCorporationIds: string[];
}
